import React from "react";
import { X, Check, Share2, Mail, MessageCircle, Calendar } from "lucide-react";

export const InviteModal = ({
  inviteBooking, setInviteBooking, inviteText, setInviteText,
  inviteCopied, shareInviteWhatsApp, shareInviteEmail, copyInviteText,
}) => {
  if (!inviteBooking) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setInviteBooking(null)}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-[#1E1B4B]">Invite Friends to Your Event</h3>
          <button onClick={() => setInviteBooking(null)} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
        </div>

        <div className="bg-gradient-to-r from-[#E83E8C]/10 to-[#FF9F1C]/10 rounded-xl p-3 mb-4 text-sm">
          <p className="font-semibold text-[#1E1B4B]">{inviteBooking.package} — {inviteBooking.occasion}</p>
          <p className="text-[#475569]">{new Date(inviteBooking.date).toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</p>
        </div>

        <label className="text-xs font-medium text-[#475569] uppercase tracking-wider mb-1 block">Edit your invite message</label>
        <textarea
          value={inviteText}
          onChange={(e) => setInviteText(e.target.value)}
          className="w-full border-2 border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-[#E83E8C] mb-4 leading-relaxed"
          rows={8}
          data-testid="invite-text-editor"
        />

        <div className="space-y-2">
          <button onClick={shareInviteWhatsApp} className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl bg-[#25D366] text-white font-semibold text-sm hover:bg-[#1da851] transition-colors" data-testid="invite-share-whatsapp">
            <MessageCircle size={16} /> Share via WhatsApp
          </button>
          <button onClick={shareInviteEmail} className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl bg-[#1E1B4B] text-white font-semibold text-sm hover:bg-[#312E81] transition-colors" data-testid="invite-share-email">
            <Mail size={16} /> Share via Email
          </button>
          <button onClick={copyInviteText} className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl border-2 border-gray-200 text-[#1E1B4B] font-medium text-sm hover:bg-gray-50 transition-colors" data-testid="invite-copy-text">
            {inviteCopied ? <><Check size={16} className="text-green-500" /> Copied!</> : <><Share2 size={16} /> Copy Invite Text</>}
          </button>
        </div>

        <p className="text-[10px] text-[#94a3b8] mt-3 text-center">Want a custom designed invite? <a href="/invitations" className="text-[#E83E8C] underline">Create one here</a></p>
      </div>
    </div>
  );
};

export const EditBookingModal = ({
  editRequest, setEditRequest, editChanges, setEditChanges,
  editSubmitting, handleEditBookingSubmit,
}) => {
  if (!editRequest) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setEditRequest(null)}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6" onClick={e => e.stopPropagation()} data-testid="edit-booking-modal">
        <h3 className="text-lg font-bold text-[#1E1B4B] mb-1">Request Booking Changes</h3>
        <p className="text-sm text-[#475569] mb-1">Booking <span className="font-semibold">{editRequest.id}</span> — {editRequest.package} on {new Date(editRequest.date).toLocaleDateString('en-IN', {day:'numeric',month:'short'})}</p>
        <p className="text-xs text-[#94a3b8] mb-4">Our team will review your request and update you via WhatsApp & Email.</p>
        <textarea value={editChanges} onChange={(e) => setEditChanges(e.target.value)} placeholder="Describe what you'd like to change (e.g., date, time, add-ons, address, package upgrade...)" className="w-full border-2 border-gray-200 rounded-xl p-3 text-sm outline-none focus:border-[#E83E8C] mb-3" rows={4} data-testid="edit-changes-textarea" />
        <div className="flex gap-2">
          <button onClick={handleEditBookingSubmit} disabled={!editChanges.trim() || editSubmitting} className="flex-1 py-2.5 rounded-xl bg-[#E83E8C] text-white font-semibold text-sm disabled:opacity-50" data-testid="submit-edit-btn">
            {editSubmitting ? "Submitting..." : "Submit Request"}
          </button>
          <button onClick={() => setEditRequest(null)} className="px-4 py-2.5 rounded-xl border border-gray-200 text-[#475569] text-sm">Cancel</button>
        </div>
      </div>
    </div>
  );
};
